import { render } from "./PlumbingSetup.vue?vue&type=template&id=42edf2a1"
import script from "./PlumbingSetup.vue?vue&type=script&lang=js"
export * from "./PlumbingSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__